import * as React from 'react'

import * as api from '@owl-nest/api-client/latest'
import { tnc, tn } from '@owl-nest/localize'

export function DiscordRoleList(rewardSocials: api.Reward['socials']) {
  if (rewardSocials === undefined) {
    return ''
  }

  return tnc('Discord role [roles]', 'Discord roles [roles]', rewardSocials.length, {
    roles: () => {
      return <em>{formatDiscordRoles(rewardSocials)}</em>
    },
  })
}

export function discordRoleListString(rewardSocials: api.Reward['socials']) {
  if (rewardSocials === undefined) {
    return ''
  }

  return tn('Discord role %(roles)s', 'Discord roles %(roles)s', rewardSocials.length, {
    roles: formatDiscordRoles(rewardSocials),
  })
}

export function formatDiscordRoles(rewardSocials: api.Reward['socials']): string {
  if (rewardSocials === undefined) {
    return ''
  }
  const lastRoleIndex = rewardSocials.length - 1

  return rewardSocials
    .map((role, index) => {
      if (index === lastRoleIndex) {
        return role.value
      }
      if (index === lastRoleIndex - 1) {
        return role.value + ' et '
      }
      return role.value + ', '
    })
    .join('')
}
